<template>
  <div>
    <el-tabs
    type="border-card"
    v-model="activeName"
    >
      <el-tab-pane
      label="查询"
      name="one"
      >
        <!-- 仓库列表查询表单 -->
        <el-divider content-position="left">仓库列表查询表单</el-divider>
        <el-form
        ref="search_form"
        :model="search_form"
        label-width="100px"
        class="search_form"
        >
          <el-form-item label="仓库" prop="warehouseKey">
            <el-input placeholder="仓库ID/仓库名" v-model="search_form.warehouseKey"></el-input>
          </el-form-item>
          <el-form-item label="仓库类型" prop="warehouseTypeKey">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.warehouseTypeKey"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in warehouseType_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="激活" prop="activeFlagKey">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.activeFlagKey"
            clearable
            >
              <el-option label="是" value="Y"></el-option>
              <el-option label="否" value="N"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="所属数据仓" prop="dataWarehouseType">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.dataWarehouseType"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in dataWarehouseType_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item class="form_other">
            <el-button
            type="primary"
            icon="el-icon-search"
            class="operate_btn"
            @click="search_storage"
            v-if="btn_permission.includes('middle:warehouse:list')||btn_permission.includes('superAdmin')"
            >查询</el-button>
            <el-button
            icon="el-icon-close"
            class="operate_btn"
            @click="reset_storage"
            v-if="btn_permission.includes('middle:warehouse:list')||btn_permission.includes('superAdmin')"
            >重置</el-button>
            <el-button
            class="operate_btn"
            type="success"
            @click="sync_warehouse()"
            v-if="btn_permission.includes('middle:warehouse:sync')||btn_permission.includes('superAdmin')"
            >同步仓库</el-button>
            <el-button
            class="operate_btn"
            type="primary"
            @click="sync_temp"
            v-if="btn_permission.includes('middle:warehousePoint:sync')||btn_permission.includes('superAdmin')"
            >同步温控点</el-button>
          </el-form-item>
        </el-form>
        <!-- 仓库货主列表查询表单 -->
        <el-divider
        v-if="btn_permission.includes('middle:warehouseCustomer:list')||btn_permission.includes('superAdmin')"
        content-position="left">仓库货主列表查询表单</el-divider>
        <el-form
        ref="customer_form"
        :model="customer_form"
        label-width="100px"
        class="customer_form"
        >
          <el-form-item
          v-if="btn_permission.includes('middle:warehouseCustomer:list')||btn_permission.includes('superAdmin')"
          label="关键字"
          prop="customerKey">
            <el-input placeholder="货主ID/名称" v-model="customer_form.customerKey"></el-input>
          </el-form-item>
          <el-form-item
          v-if="btn_permission.includes('middle:warehouseCustomer:list')||btn_permission.includes('superAdmin')"
          label="货主类型"
          prop="customerType">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="customer_form.customerType"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in customerType_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
          v-if="btn_permission.includes('middle:warehouseCustomer:list')||btn_permission.includes('superAdmin')"
          label="激活"
          prop="customerActiveFlag">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="customer_form.customerActiveFlag"
            clearable
            >
              <el-option label="是" value="Y"></el-option>
              <el-option label="否" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form_other">
            <el-button
            type="primary"
            icon="el-icon-search"
            class="operate_btn"
            @click="search_customer"
            v-if="btn_permission.includes('middle:warehouseCustomer:list')||btn_permission.includes('superAdmin')"
            >查询</el-button>
            <el-button
            icon="el-icon-close"
            class="operate_btn"
            @click="reset_customer"
            v-if="btn_permission.includes('middle:warehouseCustomer:list')||btn_permission.includes('superAdmin')"
            >重置</el-button>
            <el-button
            type="success"
            class="operate_btn"
            @click="sync_customer()"
            v-if="btn_permission.includes('middle:warehouseCustomer:sync')||btn_permission.includes('superAdmin')"
            >同步货主</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
      label="列表"
      name="two"
      >
        <!-- 仓库管理列表 -->
        <el-divider content-position="left">仓库列表</el-divider>
        <el-table
        highlight-current-row
        :data="list_data"
        border
        ref="storage_check_detail"
        @row-dblclick="storage_check_detail"
        >
          <el-table-column
          align="center"
          type="index"
          label="No"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="warehouseName"
          label="仓库名称"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="activeFlag"
          label="激活"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="address"
          label="地址"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="contact"
          label="联系人"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="contactTel"
          label="联系电话"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="warehouseTypeText"
          label="仓库类型"
          ></el-table-column>
        </el-table>
        <!-- 仓库管理列表分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="storage_size_change"
        @current-change="storage_current_change"
        :current-page="storage_current_page"
        :page-sizes="[10,15,20,25]"
        :page-size="storage_page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="storage_total"
        ></el-pagination>
        <!-- 仓库货主列表 -->
        <div v-if="btn_permission.includes('middle:warehouseCustomer:list')||btn_permission.includes('superAdmin')">
          <el-divider content-position="left">仓库货主列表</el-divider>
          <el-table
          :data="customer_data"
          border
          max-height="400"
          >
            <el-table-column
            align="center"
            type="index"
            label="No"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="customerId"
            label="货主ID"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="customerName"
            label="货主名称"
            ></el-table-column>
            <el-table-column align="center" prop="customerType" label="货主类型">
              <!-- <template slot-scope="scope">
                <el-select
                style="width: 100%;"
                ref="change_customer_type"
                :popper-append-to-body="true"
                v-model="scope.row.customerType"
                @change="change_customerType($event,scope.row)"
                clearable
                >
                  <el-option
                  v-for="item in customerType_list_new"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </template> -->
            </el-table-column>
            <el-table-column
            align="center"
            prop="activeFlag"
            label="是否激活"
            ></el-table-column>
          </el-table>
          <!-- 仓库货主列表分页 -->
          <el-pagination
          style="margin: 10px auto;"
          background
          @size-change="customer_size_change"
          @current-change="customer_current_change"
          :current-page="customer_current_page"
          :page-sizes="[10,15,20,25]"
          :page-size="customer_page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="customer_total"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane
      label="明细"
      name="three"
      class="el_details_row"
      >
        <!-- 仓库管理明细列表 -->
        <el-table
        :data="list_data"
        highlight-current-row
        border
        max-height="400"
        ref="db_detail_list"
        class="db_detail_list"
        @row-dblclick="db_detail_list"
        >
          <el-table-column
          align="center"
          type="index"
          label="No"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="warehouseId"
          label="仓库ID"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="warehouseName"
          label="仓库名称"
          ></el-table-column>
          <el-table-column
          prop="dockType"
          width="150px"
          fixed="right"
          v-if="btn_permission.includes('middle:warehouse:bind')||btn_permission.includes('superAdmin')"
          align="center"
          label="绑定温控平台">
            <template slot-scope="scope">
              <el-select
              :popper-append-to-body="true"
              v-model="scope.row.dockType"
              placeholder="请选择"
              @change="about_us_change($event,scope.row)"
              >
                <el-option
                v-for="item in about_us_list"
                :key="item.value"
                :label="item.name"
                :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <el-tabs
        type="card"
        v-model="detail_active"
        class="detail_tabs"
        @tab-click="detail_tab_click"
        >
          <el-tab-pane
          label="主信息"
          name="first"
          >
            <el-form
            ref="main_form"
            :model="main_form"
            label-width="100px"
            class="main_form"
            :rules="main_rules"
            >
              <el-divider content-position="left">基础信息</el-divider>
              <el-form-item label="仓库ID" prop="warehouseId">
                <el-input :disabled="warehouseId_status" placeholder="输入仓库ID" v-model="main_form.warehouseId"></el-input>
              </el-form-item>
              <el-form-item label="仓库名称" prop="warehouseName">
                <el-input :disabled="true" placeholder="输入仓库名称" v-model="main_form.warehouseName"></el-input>
              </el-form-item>
              <el-form-item label="仓库类型" prop="warehouseType">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="false"
                v-model="main_form.warehouseType"
                placeholder="请选择"
                :disabled="true"
                clearable
                >
                  <el-option
                  v-for="item in warehouseType_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否激活" prop="activeFlag">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="false"
                v-model="main_form.activeFlag"
                clearable
                :disabled="true"
                >
                  <el-option label="是" value="Y"></el-option>
                  <el-option label="否" value="N"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="所属数据仓" prop="dataWarehouseType">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="false"
                v-model="main_form.dataWarehouseType"
                placeholder="请选择"
                clearable
                >
                  <el-option
                  v-for="item in dataWarehouseType_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <el-divider content-position="left">相关地址</el-divider>
              <!-- <el-form-item class="form_other" label="省/市/区" prop="selectedOptions">
                <el-cascader
                style="width: 100%;"
                size="large"
                :options="options"
                v-model="main_form.selectedOptions"
                clearable
                @change="handleChange">
                </el-cascader>
              </el-form-item> -->
              <el-form-item class="form_other" label="地址" prop="address">
                <el-input :disabled="true" placeholder="输入详细地址" v-model="main_form.address"></el-input>
              </el-form-item>
              <el-form-item label="联系人" prop="contact">
                <el-input :disabled="true" placeholder="输入联系人" v-model="main_form.contact"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="contactTel">
                <el-input :disabled="true" placeholder="输入联系电话" v-model="main_form.contactTel"></el-input>
              </el-form-item>
              <!-- <el-form-item label="创建人" prop="addWho">
                <el-input :disabled="true" v-model="main_form.addWho"></el-input>
              </el-form-item>
              <el-form-item label="创建时间" prop="addTime">
                <el-input :disabled="true" v-model="main_form.addTime"></el-input>
              </el-form-item>
              <el-form-item label="修改人" prop="editWho">
                <el-input :disabled="true" v-model="main_form.editWho"></el-input>
              </el-form-item>
              <el-form-item label="修改时间" prop="editTime">
                <el-input :disabled="true" v-model="main_form.editTime"></el-input>
              </el-form-item> -->
              <!-- <el-form-item class="form_other">
                <el-button
                size="mini"
                class="operate_btn"
                type="primary"
                icon="el-icon-plus"
                :disabled="storage_add_status"
                @click="add_storage"
                v-if="btn_permission.includes('middle:warehouse:add')||btn_permission.includes('superAdmin')"
                >增加</el-button>
                <el-button
                size="mini"
                class="operate_btn"
                type="primary"
                icon="el-icon-edit"
                :disabled="storage_edit_status"
                @click="edit_storage"
                v-if="btn_permission.includes('middle:warehouse:edit')||btn_permission.includes('superAdmin')"
                >修改</el-button>
                <el-button
                size="mini"
                class="operate_btn"
                type="primary"
                icon="el-icon-delete"
                :disabled="storage_delete_status"
                @click="delete_storage"
                v-if="btn_permission.includes('middle:warehouse:del')||btn_permission.includes('superAdmin')"
                >删除</el-button>
                <el-button
                size="mini"
                class="operate_btn"
                icon="el-icon-check"
                :disabled="storage_save_status"
                @click="save_storage"
                >保存</el-button>
                <el-button
                size="mini"
                class="operate_btn"
                icon="el-icon-close"
                :disabled="storage_cancel_status"
                @click="cancel_storage"
                >取消</el-button>
              </el-form-item> -->
            </el-form>
          </el-tab-pane>
          <el-tab-pane
          label="仓库温控点"
          name="fourth"
          >
            <!-- 仓库温控点查询表单 -->
            <el-divider content-position="left">查询表单</el-divider>
            <el-form
            ref="temp_form"
            :model="temp_form"
            label-width="130px"
            class="temp_form"
            >
              <el-form-item label="关键字" prop="pointKey">
                <el-input placeholder="温控点编号/名称" v-model="temp_form.pointKey"></el-input>
              </el-form-item>
              <el-form-item label="温控点类型" prop="pointType">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="false"
                v-model="temp_form.pointType"
                placeholder="请选择"
                >
                  <el-option
                  v-for="item in pointType_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="温控点状态" prop="pointStatus">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="false"
                v-model="temp_form.pointStatus"
                placeholder="请选择"
                >
                  <el-option
                  v-for="item in pointStatus_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="operate_button">
                <el-button
                size="mini"
                type="primary"
                icon="el-icon-search"
                @click="search_temp"
                v-if="btn_permission.includes('middle:warehousePoint:list')||btn_permission.includes('superAdmin')"
                >查询</el-button>
                <el-button
                size="mini"
                icon="el-icon-close"
                @click="reset_temp"
                v-if="btn_permission.includes('middle:warehousePoint:list')||btn_permission.includes('superAdmin')"
                >重置</el-button>
                <el-button
                size="mini"
                class="operate_btn"
                type="primary"
                icon="el-icon-plus"
                @click="add_temp"
                v-if="btn_permission.includes('middle:warehousePoint:add')||btn_permission.includes('superAdmin')"
                >新增温控点</el-button>
                <el-button
                size="mini"
                type="success"
                class="operate_btn"
                v-if="btn_permission.includes('middle:warehousePoint:template')||btn_permission.includes('superAdmin')"
                @click="export_data"
                >明细模板下载</el-button>
                <el-upload
                :action="publicAjax.extra_path+'/middle/warehousePoint/importBatchByExcel/'+row_storage_now.warehouseId"
                :auto-upload="true"
                :headers="{'scctoken':upload_token}"
                name="file"
                :on-success="success_file_approval"
                :file-list="approval_file"
                :show-file-list="false"
                v-if="btn_permission.includes('middle:warehousePoint:import')||btn_permission.includes('superAdmin')"
                >
                  <el-button
                  size="mini"
                  type="success"
                  class="operate_btn"
                  >上传明细表格</el-button>
                </el-upload>
                <el-button
                size="mini"
                class="operate_btn"
                type="primary"
                @click="approvalToExcel"
                v-if="btn_permission.includes('middle:warehousePointApprove:template')||btn_permission.includes('superAdmin')"
                >审批模板下载</el-button>
                <el-upload
                style="display: inline-block;"
                :action="publicAjax.extra_path+'/middle/warehousePointApprove/import/'+row_storage_now.warehouseId"
                :auto-upload="true"
                :headers="{'scctoken':upload_token}"
                name="file"
                :on-success="success_temp_approval"
                :file-list="temp_approval_file"
                :show-file-list="false"
                ref="approval_upload"
                v-if="btn_permission.includes('middle:warehousePointApprove:import')||btn_permission.includes('superAdmin')"
                >
                  <el-button
                  size="mini"
                  type="primary"
                  class="operate_btn"
                  >审批模板上传</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            <!-- 仓库温控点列表 -->
            <el-divider content-position="left">列表</el-divider>
            <el-table
            highlight-current-row
            :data="temp_data"
            border
            max-height="400"
            >
              <el-table-column
              show-overflow-tooltip
              align="center"
              prop="pointId"
              label="温控点编号"
              ></el-table-column>
              <el-table-column
              align="center"
              prop="pointName"
              label="温控点名称"
              ></el-table-column>
              <el-table-column
              align="center"
              prop="pointStatusText"
              label="状态"
              ></el-table-column>
              <el-table-column
              align="center"
              prop="pointAreaName"
              label="区域"
              ></el-table-column>
              <el-table-column prop="" align="center" label="平台预警">
                <template slot-scope="scope">
                  <el-switch
                  v-model="scope.row.warnRecordFlag"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value="Y"
                  inactive-value="N"
                  @change="change_warn_record($event,scope.row)"
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="overheatAlertFlag" align="center" label="钉钉预警">
                <template slot-scope="scope">
                  <el-switch
                  v-model="scope.row.overheatAlertFlag"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value="Y"
                  inactive-value="N"
                  @change="change_temp_alert('flag',$event,scope.row)"
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column width="150px" prop="overheatContinueMin" align="center" label="钉钉超温阈值">
                <template slot-scope="scope">
                  <el-select
                  style="width: 100%;"
                  :popper-append-to-body="true"
                  v-model="scope.row.overheatContinueMin"
                  @change="change_temp_alert('overheatMin',$event,scope.row)"
                  >
                    <el-option label="0小时" :value="0"></el-option>
                    <el-option label="0.5小时" :value="1800"></el-option>
                    <el-option label="1小时" :value="3600"></el-option>
                    <el-option label="1.5小时" :value="5400"></el-option>
                    <el-option label="2小时" :value="7200"></el-option>
                    <el-option label="3小时" :value="10800"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" label="是否已启用">
                <template slot-scope="scope">
                  <span>{{scope.row.activeFlag=='Y'?'是':'否'}}</span>
                </template>
              </el-table-column>
              <el-table-column width="300px" fixed="right" align="center" label="操作">
                <template slot-scope="scope">
                  <el-tag
                  class="operate"
                  type=""
                  effect="dark"
                  @click="edit_temp(scope.row)"
                  v-if="btn_permission.includes('middle:warehousePoint:edit')||btn_permission.includes('superAdmin')"
                  >修改</el-tag>
                  <el-tag
                  class="operate"
                  type="danger"
                  effect="dark"
                  @click="delete_temp(scope.row)"
                  v-if="btn_permission.includes('middle:warehousePoint:del')||btn_permission.includes('superAdmin')"
                  >删除</el-tag>
                  <el-tag
                  class="operate"
                  effect="dark"
                  type="success"
                  v-if="scope.row.activeFlag=='N'&&btn_permission.includes('middle:warehousePoint:changeActiveFlag')||
                  scope.row.activeFlag=='N'&&btn_permission.includes('superAdmin')"
                  @click="open_close(scope.row)"
                  >启用</el-tag>
                  <el-tag
                  class="operate"
                  effect="dark"
                  type="warning"
                  v-if="scope.row.activeFlag=='Y'&&btn_permission.includes('middle:warehousePoint:changeActiveFlag')||
                  scope.row.activeFlag=='Y'&&btn_permission.includes('superAdmin')"
                  @click="open_close(scope.row)"
                  >禁用</el-tag>
                  <!-- <el-tag
                  class="operate"
                  type="warning"
                  effect="dark"
                  @click="close_temp(scope.row)"
                  v-if="btn_permission.includes('middle:warehousePoint:lock')||btn_permission.includes('superAdmin')"
                  >冻结</el-tag> -->
                  <el-tag
                  class="operate"
                  type="success"
                  effect="dark"
                  @click="approval_temp_before(scope.row)"
                  >审批</el-tag>
                  <el-tag
                  class="operate"
                  type="success"
                  effect="dark"
                  @click="checked_temp(scope.row)"
                  v-if="btn_permission.includes('middle:warehousePoint:getById')||btn_permission.includes('superAdmin')"
                  >查看详情</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <!-- 仓库温控点列表分页 -->
            <el-pagination
            style="margin: 10px auto;"
            background
            @size-change="temp_size_change"
            @current-change="temp_current_change"
            :current-page="temp_current_page"
            :page-sizes="[10,15,20,25]"
            :page-size="temp_page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="temp_total"
            ></el-pagination>
            <!-- 仓库温控点新增弹框 -->
            <el-dialog
            :append-to-body="true"
            :visible.sync="tempVisible"
            :title="temp_title"
            width="60%"
            v-dialogDrag
            >
              <el-form
              ref="temp_add_form"
              :model="temp_add_form"
              label-width="130px"
              class="temp_add_form"
              :rules="temp_add_rules"
              :disabled="temp_add_form_status"
              >
                <el-form-item label="温控点编号" prop="pointId">
                  <!-- <el-cascader
                  placeholder="请选择"
                  :options="pointId_list"
                  filterable
                  :show-all-levels="false"
                  @change="pintId_expand"
                  v-model="temp_add_form.pointId"
                  >
                    <template slot-scope="{node,data}">
                      <span>{{data.label}}--{{data.value}}</span>
                      <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                    </template>
                  </el-cascader> -->
                  <el-select
                  style="width: 100%;"
                  :popper-append-to-body="false"
                  v-model="temp_add_form.pointId"
                  placeholder="请选择"
                  clearable
                  filterable
                  @change="pintId_expand"
                  >
                    <el-option
                    v-for="item in pointId_list"
                    :key="item.value"
                    :label="item.name==item.value?item.name:item.name+'--'+item.value"
                    :value="item.value"
                    :disabled="item.disabled"
                    >
                      <!-- <span v-if="item.name!=item.value">{{item.name}}--{{item.value}}</span> -->
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="温控点名称" prop="pointName">
                  <el-input v-model="temp_add_form.pointName"></el-input>
                </el-form-item>
                <el-form-item label="温控上限" prop="upLimit">
                  <el-input type="number" v-model="temp_add_form.upLimit"></el-input>
                </el-form-item>
                <el-form-item label="温控下限" prop="lowerLimit">
                  <el-input type="number" v-model="temp_add_form.lowerLimit"></el-input>
                </el-form-item>
                <el-form-item label="预警上限" prop="warnUpLimit">
                  <el-input type="number" v-model="temp_add_form.warnUpLimit"></el-input>
                </el-form-item>
                <el-form-item label="预警下限" prop="warnLowerLimit">
                  <el-input type="number" v-model="temp_add_form.warnLowerLimit"></el-input>
                </el-form-item>
                <el-form-item label="温控点类型" prop="pointType">
                  <el-select
                  style="width: 100%;"
                  :popper-append-to-body="false"
                  v-model="temp_add_form.pointType"
                  placeholder="请选择"
                  clearable
                  >
                    <el-option
                    v-for="item in pointType_list"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                    :disabled="item.disabled"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="平台超温预警" prop="warnRecordFlag">
                  <el-select
                  style="width: 100%;"
                  :popper-append-to-body="false"
                  v-model="temp_add_form.warnRecordFlag"
                  clearable
                  >
                    <el-option label="否" value="N"></el-option>
                    <el-option label="是" value="Y"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="钉钉超温预警" prop="overheatAlertFlag">
                  <el-select
                  style="width: 100%;"
                  :popper-append-to-body="false"
                  v-model="temp_add_form.overheatAlertFlag"
                  clearable
                  >
                    <el-option label="否" value="N"></el-option>
                    <el-option label="是" value="Y"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="钉钉超温阈值" prop="overheatContinueMin">
                  <el-select
                  style="width: 100%;"
                  :popper-append-to-body="false"
                  v-model="temp_add_form.overheatContinueMin"
                  clearable
                  >
                    <el-option label="0小时" :value="0"></el-option>
                    <el-option label="0.5小时" :value="1800"></el-option>
                    <el-option label="1小时" :value="3600"></el-option>
                    <el-option label="1.5小时" :value="5400"></el-option>
                    <el-option label="2小时" :value="7200"></el-option>
                    <el-option label="3小时" :value="10800"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="温控点仓库" prop="pointWarehouseId">
                  <el-input :disabled="true" v-model="temp_add_form.pointWarehouseId"></el-input>
                </el-form-item>
                <el-form-item label="温控点区域" prop="pointAreaId">
                  <el-select
                  style="width: 100%;"
                  ref="pointAreaId"
                  :popper-append-to-body="false"
                  v-model="temp_add_form.pointAreaId"
                  placeholder="请选择"
                  clearable
                  @change="change_pointAreaId"
                  >
                    <el-option
                    v-for="item in areaKey_list"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                    :disabled="item.disabled"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="温控点库区" prop="pointZoneId">
                  <el-select
                  style="width: 100%;"
                  :popper-append-to-body="false"
                  v-model="temp_add_form.pointZoneId"
                  placeholder="请选择"
                  clearable
                  @clear="clear_pointZoneId"
                  >
                    <el-option
                    v-for="item in pointZoneId_list"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                    :disabled="item.disabled"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="温控点状态" prop="temp_add_pointStatus">
                  <el-select
                  style="width: 100%;"
                  :disabled="true"
                  :popper-append-to-body="false"
                  v-model="temp_add_pointStatus"
                  placeholder="请选择"
                  clearable
                  >
                    <el-option
                    v-for="item in pointStatus_list"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                    :disabled="item.disabled"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="X坐标" prop="xCoord">
                  <el-input :disabled="true" type="number" v-model="temp_add_form.xCoord"></el-input>
                </el-form-item>
                <el-form-item label="Y坐标" prop="yCoord">
                  <el-input :disabled="true" type="number" v-model="temp_add_form.yCoord"></el-input>
                </el-form-item>
                <el-form-item label="X坐标百分比" prop="xPercent">
                  <el-input :disabled="true" type="number" v-model="temp_add_form.xPercent"></el-input>
                </el-form-item>
                <el-form-item label="Y坐标百分比" prop="yPercent">
                  <el-input :disabled="true" type="number" v-model="temp_add_form.yPercent"></el-input>
                </el-form-item> -->
                <el-form-item class="form_other" label="备注" prop="notes">
                  <el-input type="textarea" v-model="temp_add_form.notes"></el-input>
                </el-form-item>
                <el-form-item class="form_other">
                  <el-button
                  type="primary"
                  icon="el-icon-circle-check"
                  @click="save_temp"
                  >保存</el-button>
                  <el-button
                  icon="el-icon-circle-close"
                  @click="cancel_temp"
                  >关闭</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
            <!-- 温控点审批预览文件 -->
            <el-dialog
            :append-to-body="true"
            :visible.sync="approvalVisible"
            :fullscreen="true"
            title="预览文件"
            >
              <iframe
              :src="approval_path_url+'?auth_token='+upload_token"
              frameborder="0"
              style="width: 100%;height: 700px"
              ></iframe>
            </el-dialog>
            <!-- 仓库温控点审批弹框 -->
            <el-dialog
            width="80%"
            top="3vh"
            class="approval_dialog"
            :append-to-body="true"
            :visible.sync="approval_show_flag"
            title="仓库温控点审批"
            >
              <!-- 温控点审批列表 -->
              <!-- <el-divider content-position="left">列表</el-divider> -->
              <el-table
              highlight-current-row
              :data="approval_data"
              border
              max-height="400"
              ref="db_approval"
              @row-dblclick="db_approval_list"
              >
                <el-table-column
                width="80px"
                align="center"
                type="index"
                label="序号"
                ></el-table-column>
                <el-table-column
                align="center"
                prop="approveFileName"
                label="证照名称"
                ></el-table-column>
                <el-table-column
                align="center"
                prop="approveNo"
                label="证照编号"
                ></el-table-column>
                <el-table-column
                show-overflow-tooltip
                align="center"
                prop="serverFileName"
                label="上传文件名"
                ></el-table-column>
                <el-table-column
                show-overflow-tooltip
                align="center"
                prop="serverFileContent"
                label="上传文件路径"
                ></el-table-column>
              </el-table>
              <!-- 温控点审批列表分页 -->
              <el-pagination
              style="margin: 10px auto;"
              background
              @size-change="approval_size_change"
              @current-change="approval_current_change"
              :current-page="approval_current_page"
              :page-sizes="[10,15,20,25]"
              :page-size="approval_page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="approval_total"
              ></el-pagination>
              <!-- 温控点审批表单 -->
              <el-divider content-position="left">操作表单</el-divider>
              <el-form
              ref="approval_form"
              :model="approval_form"
              label-width="130px"
              class="approval_form"
              :rules="approval_rules"
              >
                <el-form-item label="序号" prop="fileSeq">
                  <el-input :disabled="true" placeholder="序号" v-model="approval_form.fileSeq"></el-input>
                </el-form-item>
                <el-form-item label="仓库ID" prop="warehouseIdOfLicense">
                  <el-input :disabled="true" placeholder="仓库ID" v-model="approval_form.warehouseIdOfLicense"></el-input>
                </el-form-item>
                <el-form-item label="证照名称" prop="approveFileName">
                  <el-input placeholder="证照名称" v-model="approval_form.approveFileName"></el-input>
                </el-form-item>
                <el-form-item label="证照编号" prop="approveNo">
                  <el-input placeholder="证照编号" v-model="approval_form.approveNo"></el-input>
                </el-form-item>
                <el-form-item label="校准日期" prop="approveDate">
                  <el-date-picker
                  v-model="approval_form.approveDate"
                  type="date"
                  style="width: 100%;"
                  placeholder="校准日期"
                  value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="校准状态" prop="approveFlag">
                  <el-input :disabled="true" placeholder="校准状态" v-model="approval_form.approveFlag"></el-input>
                </el-form-item>
                <el-form-item label="校准周期" prop="approvePeriod">
                  <el-input type="number" placeholder="校准周期" v-model="approval_form.approvePeriod"></el-input>
                </el-form-item>
                <el-form-item label="预警天数" prop="alertDays">
                  <el-input type="number" placeholder="预警天数" v-model="approval_form.alertDays"></el-input>
                </el-form-item>
                <el-form-item label="创建时间" prop="addTimeOfLicense">
                  <el-input :disabled="true" placeholder="创建时间" v-model="approval_form.addTimeOfLicense"></el-input>
                </el-form-item>
                <el-form-item label="创建人" prop="addWhoOfLicense">
                  <el-input :disabled="true" placeholder="创建人" v-model="approval_form.addWhoOfLicense"></el-input>
                </el-form-item>
                <el-form-item label="修改时间" prop="editTimeOfLicense">
                  <el-input :disabled="true" placeholder="修改时间" v-model="approval_form.editTimeOfLicense"></el-input>
                </el-form-item>
                <el-form-item label="修改人" prop="editWhoOfLicense">
                  <el-input :disabled="true" placeholder="修改人" v-model="approval_form.editWhoOfLicense"></el-input>
                </el-form-item>
                <el-form-item class="form_other upload_other" label="上传文件名称" prop="serverFileName">
                  <el-input :disabled="true" placeholder="上传文件名称" v-model="approval_form.serverFileName"></el-input>
                  <el-upload
                  :action="publicAjax.extra_path+'/sccOwn/upload/image/pointLicense/'+row_approval_before_now.id"
                  :auto-upload="true"
                  :headers="{'scctoken':upload_token}"
                  name="file"
                  accept=".pdf"
                  :on-success="success_deviceLicense"
                  :file-list="deviceLicense_file"
                  :show-file-list="false"
                  ref="deviceLicense_upload"
                  >
                    <el-button
                    size="mini"
                    type="success"
                    class="operate_btn"
                    >导入文件</el-button>
                  </el-upload>
                  <el-button
                  size="mini"
                  type="infor"
                  class="operate_btn"
                  @click="picture_preview"
                  >预览文件</el-button>
                </el-form-item>
                <el-form-item class="form_other" label="上传文件路径" prop="serverFileContent">
                  <el-input :disabled="true" placeholder="上传文件路径" v-model="approval_form.serverFileContent"></el-input>
                </el-form-item>
                <el-form-item class="form_other">
                  <el-button
                  size="mini"
                  class="operate_btn"
                  type="primary"
                  icon="el-icon-plus"
                  :disabled="add_approval_status"
                  @click="add_approval"
                  v-if="btn_permission.includes('middle:warehousePointApprove:add')||btn_permission.includes('superAdmin')"
                  >增加</el-button>
                  <el-button
                  size="mini"
                  class="operate_btn"
                  type="primary"
                  icon="el-icon-edit"
                  :disabled="edit_approval_status"
                  @click="edit_approval"
                  v-if="btn_permission.includes('middle:warehousePointApprove:edit')||btn_permission.includes('superAdmin')"
                  >修改</el-button>
                  <el-button
                  size="mini"
                  class="operate_btn"
                  type="primary"
                  icon="el-icon-delete"
                  :disabled="delete_approval_status"
                  @click="delete_approval"
                  v-if="btn_permission.includes('middle:warehousePointApprove:del')||btn_permission.includes('superAdmin')"
                  >删除</el-button>
                  <el-button
                  size="mini"
                  class="operate_btn"
                  type="success"
                  :disabled="temp_approval_status"
                  @click="approval_temp"
                  v-if="btn_permission.includes('middle:warehousePointApprove:verify')||btn_permission.includes('superAdmin')"
                  >温控审批</el-button>
                  <el-button
                  size="mini"
                  class="operate_btn"
                  icon="el-icon-check"
                  :disabled="save_approval_status"
                  @click="save_approval"
                  >保存</el-button>
                  <el-button
                  size="mini"
                  class="operate_btn"
                  icon="el-icon-close"
                  :disabled="cancel_approval_status"
                  @click="cancel_approval"
                  >取消</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane
          label="仓库平面图"
          name="fifth"
          >
            <!-- 仓库平面图查询表单 -->
            <el-divider content-position="left">查询表单</el-divider>
            <el-form
            :inline="true"
            ref="plan_form"
            :model="plan_form"
            label-width="80px"
            class="plan_form"
            >
              <el-form-item label="区域" prop="areaKey">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="false"
                v-model="plan_form.areaKey"
                placeholder="请选择"
                clearable
                filterable
                >
                  <el-option
                  v-for="item in areaKey_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                type="primary"
                icon="el-icon-search"
                @click="search_plan"
                v-if="btn_permission.includes('middle:warehouseImage:list')||btn_permission.includes('superAdmin')"
                >查询</el-button>
                <el-button
                icon="el-icon-close"
                @click="reset_plan"
                v-if="btn_permission.includes('middle:warehouseImage:list')||btn_permission.includes('superAdmin')"
                >重置</el-button>
                <el-button
                icon="el-icon-sort"
                @click="sync_plan"
                v-if="btn_permission.includes('middle:warehouseImage:sync')||btn_permission.includes('superAdmin')"
                >同步区域</el-button>
              </el-form-item>
            </el-form>
            <!-- 仓库平面图列表 -->
            <el-divider content-position="left">列表</el-divider>
            <el-table
            :data="plan_data"
            border
            max-height="400"
            >
              <el-table-column
              align="center"
              prop="areaName"
              label="区域名称"
              ></el-table-column>
              <el-table-column
              show-overflow-tooltip
              align="center"
              prop="imageName"
              label="文件名称"
              ></el-table-column>
              <el-table-column width="400px" align="center" label="操作">
                <template slot-scope="scope">
                  <el-tag
                  class="operate"
                  type="success"
                  effect="dark"
                  v-if="scope.row.imageUrl!=''&&btn_permission.includes('middle:warehouseImage:getById')
                  ||scope.row.imageUrl!=''&&btn_permission.includes('superAdmin')"
                  @click="check_plan(scope.row)"
                  >查看平面图</el-tag>
                  <el-tag
                  class="operate"
                  type="warning"
                  effect="dark"
                  v-if="scope.row.imageUrl==''&&btn_permission.includes('middle:warehouseImage:edit')
                  ||scope.row.imageUrl==''&&btn_permission.includes('superAdmin')"
                  @click="upload_plan(scope.row)"
                  >上传平面图</el-tag>
                  <el-tag
                  class="operate"
                  type="warning"
                  effect="dark"
                  v-if="scope.row.imageUrl!=''&&btn_permission.includes('middle:warehouseImage:edit')
                  ||scope.row.imageUrl!=''&&btn_permission.includes('superAdmin')"
                  @click="edit_plan(scope.row)"
                  >修改平面图</el-tag>
                  <el-tag
                  class="operate"
                  type="danger"
                  effect="dark"
                  v-if="scope.row.imageUrl!=''&&btn_permission.includes('middle:warehouseImage:delImage')
                  ||scope.row.imageUrl!=''&&btn_permission.includes('superAdmin')"
                  @click="delete_plan(scope.row)"
                  >删除平面图路径</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <!-- 仓库平面图列表分页 -->
            <el-pagination
            style="margin: 10px auto;"
            background
            @size-change="plan_size_change"
            @current-change="plan_current_change"
            :current-page="plan_current_page"
            :page-sizes="[10,15,20,25]"
            :page-size="plan_page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="plan_total"
            ></el-pagination>
           <!-- 上传或修改平面图弹框 -->
           <el-dialog
           :append-to-body="true"
           :visible.sync="planVisible"
           :title="plan_title"
           width="60%"
           >
             <el-form
             ref="plan_add_form"
             :model="plan_add_form"
             label-width="100px"
             class="plan_add_form"
             >
               <el-form-item label="仓库">
                 <el-input :disabled="true" v-model="plan_add_form.warehouseId"></el-input>
               </el-form-item>
               <el-form-item label="区域">
                 <el-input :disabled="true" v-model="plan_add_form.areaId"></el-input>
               </el-form-item>
               <el-form-item label="上传文件路径">
                 <el-input :disabled="true" v-model="plan_add_form.imageUrl"></el-input>
               </el-form-item>
               <el-form-item class="upload_other" label="上传文件名称">
                 <el-input style="width: 80%;" :disabled="true" v-model="plan_add_form.serverFileName"></el-input>
                 <el-upload
                 :action="publicAjax.extra_path+'/sccOwn/upload/image/warehouse/'+row_storage_now.warehouseId"
                 :auto-upload="true"
                 :headers="{'scctoken':upload_token}"
                 name="file"
                 accept=".png,.jpg"
                 :on-success="success_plan"
                 :file-list="plan_file"
                 :show-file-list="false"
                 ref="plan_upload"
                 >
                   <i style="font-size: 28px;color: #007DDB;" class="el-icon-upload"></i>
                 </el-upload>
               </el-form-item>
             </el-form>
             <!-- 区域温控点列表 -->
             <el-divider content-position="left">区域温控点</el-divider>
             <el-table
             :data="plan_temp_data"
             border
             max-height="400"
             >
               <el-table-column
               align="center"
               prop="pointId"
               label="温控点编号"
               ></el-table-column>
               <el-table-column
               align="center"
               prop="pointName"
               label="温控点名称"
               ></el-table-column>
             </el-table>
             <!-- 区域温控点列表分页 -->
             <el-pagination
             style="margin: 10px auto;"
             background
             @size-change="plan_temp_size_change"
             @current-change="plan_temp_current_change"
             :current-page="plan_temp_current_page"
             :page-sizes="[10,15,20,25]"
             :page-size="plan_temp_page_size"
             layout="total, sizes, prev, pager, next, jumper"
             :total="plan_temp_total"
             ></el-pagination>
           </el-dialog>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { regionData , CodeToText } from "element-china-area-data";
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        activeName:'one',
        //仓库类型下拉框
        warehouseType_list:[],
        //数据仓库类型下拉框
        dataWarehouseType_list:[],
        //查询表单
        search_form:{
          warehouseKey:'',
          warehouseTypeKey:'',
          activeFlagKey:'Y',
          dataWarehouseType:''
        },
        //仓库管理列表
        list_data:[],
        //温控点关联平台下拉列表
        about_us_list:[],
        //仓库管理当前行数据
        row_storage_now:{},
        //仓库管理列表分页
        storage_current_page:1,
        storage_page_size:10,
        storage_total:0,
        //明细tab切换
        detail_active:'first',
        //新增、修改仓库判断条件
        storage_add_edit:'',
        //主信息表单禁用状态
        warehouseId_status:true,
        storage_add_status:false,
        storage_edit_status:false,
        storage_delete_status:false,
        storage_save_status:true,
        storage_cancel_status:true,
        //主信息表单正则
        main_rules:{
          // warehouseId:[
          //   {required:true,message:'请输入仓库ID',trigger:'blur'}
          // ],
          // warehouseName:[
          //   {required:true,message:'请输入仓库名称',trigger:'blur'}
          // ],
          // warehouseType:[
          //   {required:true,message:'请选择仓库类型',trigger:'change'}
          // ],
          // dataWarehouseType:[
          //   {required:true,message:'请选择所属数据仓',trigger:'change'}
          // ],
          // selectedOptions:[
          //   {required:true,message:'请选择省/市/区',trigger:'change'}
          // ],
          // address:[
          //   {required:true,message:'请输入详细地址',trigger:'blur'}
          // ],
          // contact:[
          //   {required:true,message:'请输入联系人',trigger:'blur'}
          // ],
          // contactTel:[
          //   {required:true,message:'请输入联系电话',trigger:'blur'}
          // ]
        },
        //省市区
        options:regionData,
        //主信息新增表单
        main_form:{
          warehouseId:'',
          warehouseName:'',
          warehouseType:'',
          activeFlag:'Y',
          dataWarehouseType:'',
          selectedOptions:[],
          province:'',
          city:'',
          district:'',
          address:'',
          contact:'',
          contactTel:'',
          addWho:'',
          addTime:'',
          editWho:'',
          editTime:''
        },
        //货主类型下拉框
        customerType_list:[],
        customerType_list_new:[],
        //仓库货主信息查询表单
        customer_form:{
          customerKey:'',
          customerType:'',
          customerActiveFlag:'Y'
        },
        //仓库货主列表
        customer_data:[],
        //仓库货主列表分页
        customer_current_page:1,
        customer_page_size:10,
        customer_total:0,
        //温控点类型下拉框
        pointType_list:[],
        //温控点状态下拉框
        pointStatus_list:[],
        //仓库温控点查询表单
        temp_form:{
          pointKey:'',
          pointType:'',
          pointStatus:''
        },
        //仓库温控点新增弹框
        tempVisible:false,
        temp_title:'',
        temp_add_edit:'',
        temp_add_form_status:false,
        temp_add_pointStatus:'',
        row_temp_now:{},
        pointId_status:false,
        //仓库温控点编号下拉框
        pointId_list:[],
        //仓库温控点新增表单
        temp_add_form:{
          pointId:'',
          pointName:'',
          upLimit:'',
          lowerLimit:'',
          warnUpLimit:'',
          warnLowerLimit:'',
          pointType:'',
          warnRecordFlag:'N',
          overheatAlertFlag:'N',
          overheatContinueMin:'',
          pointWarehouseId:'',
          pointAreaId:'',
          pointAreaName:'',
          // pointZoneId:'',
          // pointStatus:'',
          // xCoord:'',
          // yCoord:'',
          // xPercent:'',
          // yPercent:'',
          notes:''
        },
        //仓库温控点新增正则
        temp_add_rules:{
          pointId:[
            {required:true,message:'请输入温控点编号',trigger:'change'}
          ],
          pointName:[
            {required:true,message:'请输入温控点名称',trigger:'blur'}
          ],
          upLimit:[
            {required:true,message:'请输入温控上限',trigger:'blur'}
          ],
          lowerLimit:[
            {required:true,message:'请输入温控下限',trigger:'blur'}
          ],
          pointType:[
            {required:true,message:'请选择温控点类型',trigger:'change'}
          ],
          warnRecordFlag:[
            {required:true,message:'请选择平台预警状态',trigger:'change'}
          ],
          overheatAlertFlag:[
            {required:true,message:'请选择钉钉预警状态',trigger:'change'}
          ],
          pointWarehouseId:[
            {required:true,message:'请输入温控点仓库',trigger:'blur'}
          ],
          pointAreaId:[
            {required:true,message:'请选择温控点区域',trigger:'change'}
          ],
          // pointStatus:[
          //   {required:true,message:'请选择温控点状态',trigger:'change'}
          // ]
        },
        //仓库温控点上传明细表格
        approval_file:[],
        //仓库温控点列表
        temp_data:[],
        //仓库温控点列表分页
        temp_current_page:1,
        temp_page_size:10,
        temp_total:0,
        //仓库温控点审批弹框显影
        approval_show_flag:false,
        //温控点审批列表
        approval_data:[],
        //温控点审批当前行数据
        row_approval_now:{},
        row_approval_before_now:{},
        //温控点审批列表分页
        approval_current_page:1,
        approval_page_size:10,
        approval_total:0,
        //新增、修改温控点审批判断条件
        approval_add_edit:'',
        //温控点审批表单正则
        approval_rules:{
          approveFileName:[
            {required:true,message:'请输入证照名称',trigger:'blur'}
          ],
          approveNo:[
            {required:true,message:'请输入证照编号',trigger:'blur'}
          ],
          // serverFileContent:[
          //   {required:true,message:'请导入文件',trigger:'change'}
          // ],
          approveDate:[
            {required:true,message:'请选择校准日期',trigger:'change'}
          ],
          approvePeriod:[
            {required:true,message:'请输入校准周期',trigger:'blur'}
          ],
          alertDays:[
            {required:true,message:'请输入预警天数',trigger:'blur'}
          ]
        },
        //温控点审批上传文件
        upload_token:localStorage.getItem(localStorage.getItem('userName')+'token'),
        deviceLicense_file:[],
        temp_approval_file:[],
        //温控点审批预览文件
        approvalVisible:false,
        approval_path_url:'',
        //温控点审批表单禁用状态
        add_approval_status:false,
        edit_approval_status:false,
        delete_approval_status:false,
        temp_approval_status:false,
        save_approval_status:true,
        cancel_approval_status:true,
        //温控点审批表单
        approval_form:{
          fileSeq:'',
          warehouseIdOfLicense:'',
          approveFileName:'',
          approveNo:'',
          serverFileContent:'',
          serverFileName:'',
          serverFileMd5:'',
          approveDate:'',
          approveFlag:'',
          approvePeriod:'',
          alertDays:'',
          addTimeOfLicense:'',
          addWhoOfLicense:'',
          editTimeOfLicense:'',
          editWhoOfLicense:''
        },
        //区域下拉框
        areaKey_list:[],
        //库区下拉框
        // pointZoneId_list:[],
        //仓库平面图查询表单
        plan_form:{
          areaKey:''
        },
        //仓库平面图列表
        plan_data:[],
        row_plan_now:{},
        //仓库平面图列表分页
        plan_current_page:1,
        plan_page_size:10,
        plan_total:0,
        //上传或修改平面图弹框
        planVisible:false,
        plan_title:'',
        plan_add_form:{
          warehouseId:'',
          areaId:'',
          imageUrl:'',
          serverFileName:''
        },
        plan_file:[],
        //区域温控点列表
        plan_temp_data:[],
        //区域温控点列表分页
        plan_temp_current_page:1,
        plan_temp_page_size:10,
        plan_temp_total:0
      }
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //仓库类型下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/byCode/warehouseType'
      }).then(data=>{
        if(data.data.success==true){
          that.warehouseType_list=data.data.data
        }
      })
      //数据仓库类型下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/byCode/dataWarehouseType'
      }).then(data=>{
        if(data.data.success==true){
          that.dataWarehouseType_list=data.data.data
          that.search_form.dataWarehouseType=that.dataWarehouseType_list[0].value
        }
      })
      //货主类型下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/byCode/warehouseCustomerType'
      }).then(data=>{
        if(data.data.success==true){
          that.customerType_list=data.data.data
        }
      })
      //温控点类型下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/byCode/pointType'
      }).then(data=>{
        if(data.data.success==true){
          that.pointType_list=data.data.data
        }
      })
      //温控点状态下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/byCode/pointStatus'
      }).then(data=>{
        if(data.data.success==true){
          that.pointStatus_list=data.data.data
        }
      })
    },
    mounted() {

    },
    watch:{

    },
    methods:{
      //获取仓库管理列表
      get_storage(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehouse/list',
          params:{
            page:that.storage_current_page,
            limit:that.storage_page_size,
            warehouseKey:that.search_form.warehouseKey,
            warehouseTypeKey:that.search_form.warehouseTypeKey,
            activeFlagKey:that.search_form.activeFlagKey
          }
        }).then(data=>{
          if(data.data.success==true){
            that.list_data=data.data.data.list
            that.storage_total=data.data.data.total
            if(that.storage_add_edit=='edit'||that.storage_add_edit=='bind'){
              that.list_data.forEach(item=>{
                if(item.warehouseId==that.row_storage_now.warehouseId){
                  that.row_storage_now=item
                }
              })
              that.db_detail_list(that.row_storage_now)
            }else{
              that.db_detail_list(that.list_data[0])
            }
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //查询仓库管理列表
      search_storage(){
        this.storage_current_page=1
        this.storage_page_size=10
        this.activeName='two'
        //获取仓库管理列表
        this.get_storage()
      },
      //重置仓库管理查询表单
      reset_storage(){
        this.$refs.search_form.resetFields()
        this.storage_current_page=1
        this.storage_page_size=10
        //获取仓库管理列表
        this.get_storage()
      },
      //同步仓库
      sync_warehouse(){
        let that=this
        that.$axios({
          method:'put',
          url:that.publicAjax.extra_path+'/middle/warehouse/synchronized'
        }).then(data=>{
          if(data.data.success==true){
            //获取仓库管理列表
            that.get_storage()
            that.$message.success(data.data.message)
          }else{
            that.list_data=[]
            that.$message.warning(data.data.message)
          }
        })
      },
      //仓库管理列表双击事件
      storage_check_detail(row,column,event){
        this.activeName='three'
        //仓库管理明细双击事件
        this.db_detail_list(row,column,event)
      },
      //仓库管理明细双击事件
      db_detail_list(row,column,event){
        this.storage_add_edit=''
        if(row==undefined){
          return false
        }
        //主信息表单禁用状态
        this.warehouseId_status=true
        this.storage_add_status=false
        this.storage_edit_status=false
        this.storage_delete_status=false
        this.storage_save_status=true
        this.storage_cancel_status=true
        //选中当前行
        this.$refs.db_detail_list.setCurrentRow(row)
        //重置主信息表单校验
        this.$refs.main_form.clearValidate()
        //仓库管理当前行数据
        this.row_storage_now=row
        //获取温控设备关联平台
        this.get_temp_device_list()
        //区域下拉框
        this.get_areaKey()
        //获取仓库温控点列表
        this.get_temp()
        //获取仓库平面图列表
        this.get_plan()
        //主信息表单回显
        this.main_form.warehouseId=row.warehouseId
        this.main_form.warehouseName=row.warehouseName
        this.main_form.warehouseType=row.warehouseType
        this.main_form.activeFlag=row.activeFlag
        this.main_form.dataWarehouseType=row.dataWarehouseType
        this.main_form.selectedOptions=[row.province,row.city,row.district]
        this.main_form.address=row.address
        this.main_form.contact=row.contact
        this.main_form.contactTel=row.contactTel
        this.main_form.addWho=row.addWho
        this.main_form.addTime=row.addTime
        this.main_form.editWho=row.editWho
        this.main_form.editTime=row.editTime
      },
      //同步温控点
      sync_temp(){
        let that=this
        that.$axios({
          method:'put',
          url:that.publicAjax.extra_path+'/middle/warehouse/sync/point'
        }).then(data=>{
          if(data.data.success==true){
            that.$message.success(data.data.message)
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //温控关联平台change事件
      about_us_change(val,row){
        let that=this
        that.storage_add_edit='bind'
        that.$confirm('是否绑定温控平台?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'put',
            url:that.publicAjax.extra_path+'/middle/warehouse/bind/'+row.warehouseId+'/'+val
          }).then(data=>{
            if(data.data.success==true){
              //获取仓库管理列表
              that.get_storage()
              that.$message.success(data.data.message)
            }else{
              //获取仓库管理列表
              that.get_storage()
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{
          //获取仓库管理列表
          that.get_storage()
        })
      },
      //获取温控设备关联平台
      get_temp_device_list(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/dict/select/byCode/warehousePointDockType'
        }).then(data=>{
          if(data.data.success==true){
            that.about_us_list=data.data.data
            // that.about_us=that.about_us_list[0].value
          }
        })
      },
      //字段disable为true,为不可选中状态，反之选中
      // selectEnable(row,rowIndex){
      //   if(row.disable==false){
      //     return true
      //   }else{
      //     return false
      //   }
      // },
      //明细标签页tabs点击事件
      detail_tab_click(tab,event){

      },
      //省市区三级联动
      handleChange(val){

      },
      //仓库管理列表分页
      storage_size_change(val){
        this.storage_page_size=val
        //获取仓库管理列表
        this.get_storage()
      },
      storage_current_change(val){
        this.storage_current_page=val
        //获取仓库管理列表
        this.get_storage()
      },
      //新增仓库管理前置
      add_storage(){
        this.storage_add_edit='add'
        //主信息表单禁用状态
        this.warehouseId_status=false
        this.storage_add_status=true
        this.storage_edit_status=true
        this.storage_delete_status=true
        this.storage_save_status=false
        this.storage_cancel_status=false
        //重置主信息表单
        this.$refs.main_form.resetFields()
      },
      //修改仓库管理前置
      edit_storage(){
        this.storage_add_edit='edit'
        //主信息表单禁用状态
        this.warehouseId_status=true
        this.storage_add_status=true
        this.storage_edit_status=true
        this.storage_delete_status=true
        this.storage_save_status=false
        this.storage_cancel_status=false
        //重置主信息表单校验
        this.$refs.main_form.clearValidate()
      },
      //新增或修改仓库管理保存
      save_storage(){
        let that=this
        that.$refs.main_form.validate((valid)=>{
          if(valid){
            if(that.storage_add_edit=='add'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/middle/warehouse',
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  warehouseId:that.main_form.warehouseId,
                  warehouseName:that.main_form.warehouseName,
                  dataWarehouseType:that.main_form.dataWarehouseType,
                  activeFlag:that.main_form.activeFlag,
                  province:that.main_form.selectedOptions[0],
                  city:that.main_form.selectedOptions[1],
                  district:that.main_form.selectedOptions[2],
                  address:that.main_form.address,
                  contact:that.main_form.contact,
                  contactTel:that.main_form.contactTel,
                  warehouseType:that.main_form.warehouseType
                }
              }).then(data=>{
                if(data.data.success==true){
                  //获取仓库管理列表
                  that.get_storage()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }else if(that.storage_add_edit=='edit'){
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/middle/warehouse/'+that.row_storage_now.warehouseId,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  warehouseId:that.main_form.warehouseId,
                  warehouseName:that.main_form.warehouseName,
                  dataWarehouseType:that.main_form.dataWarehouseType,
                  activeFlag:that.main_form.activeFlag,
                  province:that.main_form.selectedOptions[0],
                  city:that.main_form.selectedOptions[1],
                  district:that.main_form.selectedOptions[2],
                  address:that.main_form.address,
                  contact:that.main_form.contact,
                  contactTel:that.main_form.contactTel,
                  warehouseType:that.main_form.warehouseType
                }
              }).then(data=>{
                if(data.data.success==true){
                  //获取仓库管理列表
                  that.get_storage()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //删除仓库管理
      delete_storage(){
        if(this.list_data.length==0){
          this.$message.warning('暂无数据!')
          return false
        }
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/middle/warehouse/'+that.row_storage_now.warehouseId
          }).then(data=>{
            if(data.data.success==true){
              //获取仓库管理列表
              that.get_storage()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //取消新增或修改仓库管理
      cancel_storage(){
        //仓库管理明细双击事件
        this.db_detail_list(this.row_storage_now)
      },
      //同步仓库货主
      sync_customer(){
        let that=this
        that.$axios({
          method:'put',
          url:that.publicAjax.extra_path+'/middle/warehouseCustomer/synchronized'
        }).then(data=>{
          if(data.data.success==true){
            // that.activeName='three'
            // that.detail_active='second'
            //获取仓库货主列表
            that.get_customer()
            that.$message.success(data.data.message)
          }else{
            that.customer_data=[]
            that.$message.warning(data.data.message)
          }
        })
      },
      //获取仓库货主列表
      get_customer(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehouseCustomer/list',
          params:{
            page:that.customer_current_page,
            limit:that.customer_page_size,
            customerKey:that.customer_form.customerKey,
            customerType:that.customer_form.customerType,
            customerActiveFlag:that.customer_form.customerActiveFlag
          }
        }).then(data=>{
          if(data.data.success==true){
            that.customer_data=data.data.data.list
            that.customer_total=data.data.data.total
            // that.customerType_list_new=[{disabled:null,name:'请选择',value:0}].concat(that.customerType_list)
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //更新货主类型
      // change_customerType($event,row){
      //   if(!$event){
      //     $event=0
      //   }
      //   let that=this
      //   that.$confirm('是否更新货主类型?','提示',{
      //     type:'warning'
      //   }).then(()=>{
      //     that.$axios({
      //       method:'put',
      //       url:that.publicAjax.extra_path+'/middle/warehouseCustomer/'+row.id+'/'+$event
      //     }).then(data=>{
      //       if(data.data.success==true){
      //         //获取仓库货主列表
      //         that.get_customer()
      //         that.$message.success(data.data.message)
      //       }else{
      //         that.$message.warning(data.data.message)
      //       }
      //     })
      //   }).catch(()=>{
      //       //获取仓库货主列表
      //       that.get_customer()
      //   })
      // },
      //查询仓库货主列表
      search_customer(){
        this.customer_current_page=1
        this.customer_page_size=10
        this.activeName='two'
        //获取仓库货主列表
        this.get_customer()
      },
      //重置仓库货主查询表单
      reset_customer(){
        this.$refs.customer_form.resetFields()
        this.customer_current_page=1
        this.customer_page_size=10
        //获取仓库货主列表
        this.get_customer()
      },
      //仓库货主列表分页
      customer_size_change(val){
        this.customer_page_size=val
        //获取仓库货主列表
        this.get_customer()
      },
      customer_current_change(val){
        this.customer_current_page=val
        //获取仓库货主列表
        this.get_customer()
      },
      //获取仓库温控点列表
      get_temp(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehousePoint/list',
          params:{
            warehouseId:that.row_storage_now.warehouseId,
            page:that.temp_current_page,
            limit:that.temp_page_size,
            pointKey:that.temp_form.pointKey,
            pointType:that.temp_form.pointType,
            pointStatus:that.temp_form.pointStatus
          }
        }).then(data=>{
          if(data.data.success==true){
            that.temp_data=data.data.data.list
            that.temp_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //查询仓库温控点列表
      search_temp(){
        this.temp_current_page=1
        this.temp_page_size=10
        //获取仓库温控点列表
        this.get_temp()
      },
      //重置仓库温控点查询表单
      reset_temp(){
        this.$refs.temp_form.resetFields()
        this.temp_current_page=1
        this.temp_page_size=10
        //获取仓库温控点列表
        this.get_temp()
      },
      //仓库温控点列表分页
      temp_size_change(val){
        this.temp_page_size=val
        //获取仓库温控点列表
        this.get_temp()
      },
      temp_current_change(val){
        this.temp_current_page=val
        //获取仓库温控点列表
        this.get_temp()
      },
      //仓库温控点编号下拉框
      get_pointId_list(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehouse/point/fromSelect/'+that.row_storage_now.warehouseId+'/'+that.temp_add_edit
        }).then(data=>{
          if(data.data.success==true){
            that.pointId_list=data.data.data
          }else{
            that.$message.warning(data.data.message)
            that.pointId_list=[]
          }
        })
      },
      //温控点编号change事件
      pintId_expand(val){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehousePoint/getBaseByDock/'+val
        }).then(data=>{
          if(data.data.success==true){
            let point_id_message=data.data.data
            //回显仓库温控点的基础信息
            that.temp_add_form.pointName=point_id_message.pointName
            that.temp_add_form.upLimit=point_id_message.upLimit
            that.temp_add_form.lowerLimit=point_id_message.lowerLimit
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //区域下拉框
      get_areaKey(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehouse/zoneGroup/'+that.row_storage_now.warehouseId
        }).then(data=>{
          if(data.data.success==true){
            that.areaKey_list=data.data.data
          }else{
            that.$message({
              type:'warning',
              message:data.data.message,
              duration:5000
            })
            that.areaKey_list=[]
          }
        })
      },
      //温控点区域change事件
      change_pointAreaId(value){
        this.temp_add_form.pointAreaName=this.areaKey_list.find((item)=>{
          return item.value==value
        }).name
        // this.clear_pointZoneId(this.temp_add_form.pointZoneId)
        //库区下拉框
        // this.get_pointZoneId()
      },
      // clear_pointZoneId(val){
      //   this.temp_add_form.pointZoneId=''
      // },
      //库区下拉框
      // get_pointZoneId(){
      //   let that=this
      //   that.$axios({
      //     method:'get',
      //     url:that.publicAjax.extra_path+'/middle/warehouse/zone/'+that.row_storage_now.warehouseId+'/'+that.temp_add_form.pointAreaId
      //   }).then(data=>{
      //     if(data.data.success==true){
      //       that.pointZoneId_list=data.data.data
      //     }
      //   })
      // },
      //新增仓库温控点前置
      add_temp(){
        this.tempVisible=true
        this.temp_add_form_status=false
        this.pointId_status=false
        this.temp_add_edit='add'
        this.temp_title='新增温控点'
        //仓库温控点编号下拉框
        this.get_pointId_list()
        if(this.$refs.temp_add_form!=undefined){
          this.$refs.temp_add_form.resetFields()
        }
        // this.pointZoneId_list=[]
        this.temp_add_form.pointWarehouseId=this.row_storage_now.warehouseId
      },
      //修改仓库温控点前置
      edit_temp(row){
        this.tempVisible=true
        this.temp_add_form_status=false
        this.pointId_status=true
        this.temp_add_edit='update'
        this.temp_title='修改温控点'
        this.row_temp_now=row
        //仓库温控点编号下拉框
        this.get_pointId_list()
        this.$nextTick(()=>{
          //仓库温控点表单回显
          this.temp_add_form.pointId=row.pointId
          this.temp_add_form.pointName=row.pointName
          this.temp_add_form.upLimit=row.upLimit
          this.temp_add_form.lowerLimit=row.lowerLimit
          this.temp_add_form.warnUpLimit=row.warnUpLimit
          this.temp_add_form.warnLowerLimit=row.warnLowerLimit
          this.temp_add_form.pointType=row.pointType
          this.temp_add_form.warnRecordFlag=row.warnRecordFlag
          this.temp_add_form.overheatAlertFlag=row.overheatAlertFlag
          this.temp_add_form.overheatContinueMin=row.overheatContinueMin
          this.temp_add_form.pointWarehouseId=row.pointWarehouseId
          let old_point_area=this.areaKey_list.find((item)=>{
            return item.value==row.pointAreaId
          })
          if(old_point_area!=undefined){
            this.temp_add_form.pointAreaId=old_point_area.value
          }else{
            this.temp_add_form.pointAreaId=''
          }
          // this.temp_add_form.pointAreaId=row.pointAreaId
          this.temp_add_form.pointAreaName=row.pointAreaName
          // this.temp_add_form.pointZoneId=row.pointZoneId
          this.temp_add_pointStatus=row.pointStatus
          // this.temp_add_form.xCoord=row.xCoord
          // this.temp_add_form.yCoord=row.yCoord
          // this.temp_add_form.xPercent=row.xPercent
          // this.temp_add_form.yPercent=row.yPercent
          this.temp_add_form.notes=row.notes
          //库区下拉框
          // this.get_pointZoneId()
        })
      },
      //新增或修改仓库温控点保存
      save_temp(){
        let that=this
        that.$refs.temp_add_form.validate((valid)=>{
          if(valid){
            if(that.temp_add_edit=='add'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/middle/warehousePoint',
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:that.temp_add_form
              }).then(data=>{
                if(data.data.success==true){
                  that.tempVisible=false
                  //获取仓库温控点列表
                  that.get_temp()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }else if(that.temp_add_edit=='update'){
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/middle/warehousePoint/id/'+that.row_temp_now.id,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:that.temp_add_form
              }).then(data=>{
                if(data.data.success==true){
                  that.tempVisible=false
                  //获取仓库温控点列表
                  that.get_temp()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //取消新增或修改仓库温控点
      cancel_temp(){
        this.tempVisible=false
      },
      //删除仓库温控点
      delete_temp(row){
        let that=this
        that.$confirm('该操作将清空温控点的审批记录,是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/middle/warehousePoint/'+row.id
          }).then(data=>{
            if(data.data.success==true){
              //获取仓库温控点列表
              that.get_temp()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //启用或禁用仓库温控点
      open_close(row){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'put',
            url:that.publicAjax.extra_path+'/middle/warehousePoint/changeActiveFlag/'+row.id
          }).then(data=>{
            if(data.data.success==true){
              //获取仓库温控点列表
              that.get_temp()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //冻结仓库温控点
      // close_temp(row){
      //   let that=this
      //   that.$confirm('是否继续?','提示',{
      //     type:'warning'
      //   }).then(()=>{
      //     that.$axios({
      //       method:'put',
      //       url:that.publicAjax.extra_path+'/middle/warehousePoint/lock/'+row.id
      //     }).then(data=>{
      //       if(data.data.success==true){
      //         //获取仓库温控点列表
      //         that.get_temp()
      //         that.$message.success(data.data.message)
      //       }else{
      //         that.$message.warning(data.data.message)
      //       }
      //     })
      //   }).catch(()=>{

      //   })
      // },
      //仓库温控点审批前置
      approval_temp_before(row){
        //获取仓库温控点当前行数据
        this.row_approval_before_now=row
        //仓库温控点审批弹框显影
        this.approval_show_flag=true
        //获取温控点审批列表
        this.get_approval()
      },
      //温控点审批列表双击事件
      db_approval_list(row,column,event){
        this.approval_add_edit=''
        if(row==undefined){
          //重置温控点审批表单
          this.$refs.approval_form.resetFields()
          return false
        }
        //温控点审批表单禁用状态
        this.add_approval_status=false
        this.edit_approval_status=false
        this.delete_approval_status=false
        this.temp_approval_status=false
        this.save_approval_status=true
        this.cancel_approval_status=true
        //选中当前行
        this.$refs.db_approval.setCurrentRow(row)
        //重置温控点审批表单校验
        this.$refs.approval_form.clearValidate()
        //温控点审批列表当前行数据
        this.row_approval_now=row
        //温控点审批表单回显
        this.approval_form.fileSeq=row.fileSeq
        this.approval_form.warehouseIdOfLicense=row.warehouseId
        this.approval_form.approveFileName=row.approveFileName
        this.approval_form.approveNo=row.approveNo
        this.approval_form.serverFileContent=row.serverFileContent
        this.approval_form.serverFileName=row.serverFileName
        this.approval_form.serverFileMd5=row.serverFileMd5
        this.approval_form.approveDate=row.approveDate
        this.approval_form.approveFlag=row.approveFlag
        this.approval_form.approvePeriod=row.approvePeriod
        this.approval_form.alertDays=row.alertDays
        this.approval_form.addTimeOfLicense=row.addTime
        this.approval_form.addWhoOfLicense=row.addWho
        this.approval_form.editTimeOfLicense=row.editTime
        this.approval_form.editWhoOfLicense=row.editWho
      },
      //获取温控点审批列表
      get_approval(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehousePointApprove/list/'+that.row_approval_before_now.id,
          params:{
            page:that.approval_current_page,
            limit:that.approval_page_size
          }
        }).then(data=>{
          if(data.data.success==true){
            that.approval_data=data.data.data.list
            that.approval_total=data.data.data.total
            if(that.approval_add_edit=='edit'){
              that.approval_data.forEach(item=>{
                if(item.id==that.row_approval_now.id){
                  that.row_approval_now=item
                }
              })
              that.db_approval_list(that.row_approval_now)
            }else{
              that.db_approval_list(that.approval_data[0])
            }
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //温控点审批列表分页
      approval_size_change(val){
        this.approval_page_size=val
        //获取温控点审批列表
        this.get_approval()
      },
      approval_current_change(val){
        this.approval_current_page=val
        //获取温控点审批列表
        this.get_approval()
      },
      //温控点审批导入文件成功回调
      success_deviceLicense(data,file,fileList){
        let that=this
        if(data.success==true){
          that.$message.success(data.message)
          that.approval_form.serverFileContent=that.publicAjax.image_path+data.data[0].url
          that.approval_form.serverFileName=file.name
          that.approval_form.serverFileMd5=data.data[0].md5
        }else{
          that.$message.error(data.message)
        }
      },
      //温控点审批预览文件
      picture_preview(){
        this.approvalVisible=true
        //pdf预览
        this.approval_path_url='./static/pdf/web/viewer.html?file='+encodeURIComponent(this.approval_form.serverFileContent)
      },
      //新增温控点审批前置
      add_approval(){
        this.approval_add_edit='add'
        //温控点审批表单禁用状态
        this.add_approval_status=true
        this.edit_approval_status=true
        this.delete_approval_status=true
        this.temp_approval_status=true
        this.save_approval_status=false
        this.cancel_approval_status=false
        //重置温控点审批表单
        this.$refs.approval_form.resetFields()
        this.approval_form.warehouseIdOfLicense=this.row_storage_now.warehouseId
      },
      //修改温控点审批前置
      edit_approval(){
        this.approval_add_edit='edit'
        //温控点审批表单禁用状态
        this.add_approval_status=true
        this.edit_approval_status=true
        this.delete_approval_status=true
        this.temp_approval_status=true
        this.save_approval_status=false
        this.cancel_approval_status=false
        //重置温控点审批表单校验
        this.$refs.approval_form.clearValidate()
      },
      //新增或修改温控点审批保存
      save_approval(){
        let that=this
        that.$refs.approval_form.validate((valid)=>{
          if(valid){
            if(that.approval_add_edit=='add'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/middle/warehousePointApprove',
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  pointTableId:that.row_approval_before_now.id,
                  approveDate:that.approval_form.approveDate,
                  approveFlag:that.approval_form.approveFlag,
                  approveFileName:that.approval_form.approveFileName,
                  approveNo:that.approval_form.approveNo,
                  serverFileName:that.approval_form.serverFileName,
                  serverFileContent:that.approval_form.serverFileContent,
                  serverFileMd5:that.approval_form.serverFileMd5,
                  approvePeriod:that.approval_form.approvePeriod,
                  alertDays:that.approval_form.alertDays
                }
              }).then(data=>{
                if(data.data.success==true){
                  //获取温控点审批列表
                  that.get_approval()
                  //获取仓库温控点列表
                  that.get_temp()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }else if(that.approval_add_edit=='edit'){
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/middle/warehousePointApprove/'+that.row_approval_now.id,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  pointTableId:that.row_approval_before_now.id,
                  fileSeq:that.approval_form.fileSeq,
                  approveDate:that.approval_form.approveDate,
                  approveFlag:that.approval_form.approveFlag,
                  approveFileName:that.approval_form.approveFileName,
                  approveNo:that.approval_form.approveNo,
                  serverFileName:that.approval_form.serverFileName,
                  serverFileContent:that.approval_form.serverFileContent,
                  serverFileMd5:that.approval_form.serverFileMd5,
                  approvePeriod:that.approval_form.approvePeriod,
                  alertDays:that.approval_form.alertDays
                }
              }).then(data=>{
                if(data.data.success==true){
                  //获取温控点审批列表
                  that.get_approval()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //删除温控点审批
      delete_approval(){
        if(this.approval_data.length==0){
          this.$message.warning('暂无数据!')
          return false
        }
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/middle/warehousePointApprove/'+that.row_approval_now.id+'/'+that.row_approval_before_now.id
          }).then(data=>{
            if(data.data.success==true){
              //获取温控点审批列表
              that.get_approval()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //温控审批
      approval_temp(){
        let that=this
        if(that.approval_data.length>0){
          that.$confirm('是否继续?','提示',{
            type:'warning'
          }).then(()=>{
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/middle/warehousePointApprove/verify/'+that.row_approval_now.id
            }).then(data=>{
              if(data.data.success==true){
                //获取温控点审批列表
                that.get_approval()
                //获取仓库温控点列表
                that.get_temp()
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }).catch(()=>{

          })
        }else{
          that.$message.warning('请先新增审批')
        }
      },
      //温控审批模板下载
      approvalToExcel(){
        let that=this
        that.$axios({
          url:that.publicAjax.extra_path+'/middle/warehousePointApprove/template',
          method:'get',
          responseType:'blob'
        }).then(data=>{
          if(data.data.type=='application/octet-stream'){
            let pdf_url=window.URL.createObjectURL(new Blob([data.data], {type:"application/vnd.ms-excel"}))
            let link=document.createElement('a')
            link.href=pdf_url
            link.style.display='none'
            let fname='温控点审批导入模板.xls'
            link.setAttribute('download',fname)
            document.body.appendChild(link)
            link.click()
            URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
          }else{
            const file=new FileReader()
            file.readAsText(data.data,'utf-8')
            file.onload=function(){
              const obj=JSON.parse(file.result)
              if(obj.success==false){
                that.$message.warning(obj.message)
              }
            }
          }
        })
      },
      //温控点导入审批模板
      success_temp_approval(data,file,fileList){
        if(data.success==true){
          this.$message.success(data.message)
        }else{
          this.$message.error(data.message)
        }
      },
      //取消温控点审批新增或修改
      cancel_approval(){
        //温控点审批列表双击事件
        this.db_approval_list(this.row_approval_now)
      },
      //仓库温控点是否平台预警
      change_warn_record(val,row){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'put',
            url:that.publicAjax.extra_path+'/middle/warehousePoint/warnRecord/'+row.id
          }).then(data=>{
            if(data.data.success==true){
              //获取仓库温控点列表
              that.get_temp()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{
          //获取仓库温控点列表
          that.get_temp()
        })
      },
      //仓库温控点是否钉钉预警
      change_temp_alert(changeField,val,row){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'put',
            url:that.publicAjax.extra_path+'/middle/warehousePoint/alert/'+row.id+'/'+changeField+'/'+val
          }).then(data=>{
            if(data.data.success==true){
              //获取仓库温控点列表
              that.get_temp()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{
          //获取仓库温控点列表
          that.get_temp()
        })
      },
      //查看仓库温控点详情
      checked_temp(row){
        this.tempVisible=true
        this.temp_add_form_status=true
        this.temp_title='查看仓库温控点详情'
        //仓库温控点表单回显
        this.temp_add_form.pointId=row.pointId
        this.temp_add_form.pointName=row.pointName
        this.temp_add_form.upLimit=row.upLimit
        this.temp_add_form.lowerLimit=row.lowerLimit
        this.temp_add_form.warnUpLimit=row.warnUpLimit
        this.temp_add_form.warnLowerLimit=row.warnLowerLimit
        this.temp_add_form.pointType=row.pointType
        this.temp_add_form.warnRecordFlag=row.warnRecordFlag
        this.temp_add_form.overheatAlertFlag=row.overheatAlertFlag
        this.temp_add_form.overheatContinueMin=row.overheatContinueMin
        this.temp_add_form.pointWarehouseId=row.pointWarehouseId
        this.temp_add_form.pointAreaId=row.pointAreaId
        this.temp_add_form.pointAreaName=row.pointAreaName
        // this.temp_add_form.pointZoneId=row.pointZoneId
        this.temp_add_pointStatus=row.pointStatus
        // this.temp_add_form.xCoord=row.xCoord
        // this.temp_add_form.yCoord=row.yCoord
        // this.temp_add_form.xPercent=row.xPercent
        // this.temp_add_form.yPercent=row.yPercent
        this.temp_add_form.notes=row.notes
      },
      //上传仓库温控点模板
      success_file_approval(data,file,fileList){
        if(data.success==true){
          this.$message.success(data.message)
        }else{
          this.$message.error(data.message)
        }
      },
      //下载仓库温控点模板
      export_data(){
        let that=this
        that.$axios({
          url:that.publicAjax.extra_path+'/middle/warehousePoint/template/'+that.row_storage_now.warehouseId,
          method:'get',
          responseType:'blob'
        }).then(data=>{
          if(data.data.type=='application/vnd.ms-excel'){
            let pdf_url=window.URL.createObjectURL(new Blob([data.data], {type:"application/vnd.ms-excel"}))
            let link=document.createElement('a')
            link.href=pdf_url
            link.style.display='none'
            let fname='温控点批量模板.xls'
            link.setAttribute('download',fname)
            document.body.appendChild(link)
            link.click()
            URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
          }else{
            const file=new FileReader()
            file.readAsText(data.data,'utf-8')
            file.onload=function(){
              const obj=JSON.parse(file.result)
              if(obj.success==false){
                that.$message.warning(obj.message)
              }
            }
          }
        })
      },
      //获取仓库平面图列表
      get_plan(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehouseImage/list/'+that.row_storage_now.warehouseId+'?page='+that.plan_current_page+'&limit='+that.plan_page_size,
          params:that.plan_form.areaKey==''?'':that.plan_form
        }).then(data=>{
          if(data.data.success==true){
            that.plan_data=data.data.data.list
            that.plan_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //查询仓库平面图列表
      search_plan(){
        this.plan_current_page=1
        this.plan_page_size=10
        //获取仓库平面图列表
        this.get_plan()
      },
      //重置仓库平面图查询表单
      reset_plan(){
        this.$refs.plan_form.resetFields()
        this.plan_current_page=1
        this.plan_page_size=10
        //获取仓库平面图列表
        this.get_plan()
      },
      //同步区域
      sync_plan(){
        let that=this
        that.$axios({
          method:'put',
          url:that.publicAjax.extra_path+'/middle/warehouseImage/synchronizedArea/'+that.row_storage_now.warehouseId
        }).then(data=>{
          if(data.data.success=true){
            that.$message.success(data.data.message)
            //区域下拉框
            that.get_areaKey()
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //仓库平面图列表分页
      plan_size_change(val){
        this.plan_page_size=val
        //获取仓库平面图列表
        this.get_plan()
      },
      plan_current_change(val){
        this.plan_current_page=val
        //获取仓库平面图列表
        this.get_plan()
      },
      //上传平面图前置
      upload_plan(row){
        this.planVisible=true
        this.plan_title='上传平面图'
        this.row_plan_now=row
        this.plan_add_form.warehouseId=row.warehouseId
        this.plan_add_form.areaId=row.areaId
        this.plan_add_form.warehouseId=row.warehouseId
        this.plan_add_form.imageUrl=row.imageUrl
        this.plan_add_form.serverFileName=row.imageName
        //获取区域温控点列表
        this.get_plan_temp()
      },
      //修改平面图前置
      edit_plan(row){
        this.planVisible=true
        this.plan_title='修改平面图'
        this.row_plan_now=row
        this.plan_add_form.warehouseId=row.warehouseId
        this.plan_add_form.areaId=row.areaId
        this.plan_add_form.warehouseId=row.warehouseId
        this.plan_add_form.imageUrl=row.imageUrl
        this.plan_add_form.serverFileName=row.imageName
        //获取区域温控点列表
        this.get_plan_temp()
      },
      //上传或修改平面图成功回调
      success_plan(data,file){
        let that=this
        if(data.success==true){
          that.plan_add_form.imageUrl=that.publicAjax.image_path+data.data[0].url
          that.plan_add_form.serverFileName=file.name
          //修改平面图
          that.$axios({
            method:'put',
            url:that.publicAjax.extra_path+'/middle/warehouseImage',
            headers:{
              "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
              "content-type":"application/json;charset=UTF-8"
            },
            data:{
              id:that.row_plan_now.id,
              warehouseId:that.row_plan_now.warehouseId,
              areaId:that.row_plan_now.areaId,
              areaName:that.row_plan_now.areaName,
              imageUrl:that.publicAjax.image_path+data.data[0].url,
              imageName:file.name,
              imageMd5:data.data[0].md5
            }
          }).then(data=>{
            if(data.data.success==true){
              that.$message.success(data.data.message)
              //获取仓库平面图列表
              that.get_plan()
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }else{
          that.$message.error(data.message)
        }
      },
      //获取区域温控点列表
      get_plan_temp(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehousePoint/list',
          params:{
            warehouseId:that.row_storage_now.warehouseId,
            page:that.temp_current_page,
            limit:that.temp_page_size,
            pointAreaId:that.plan_add_form.areaId
          }
        }).then(data=>{
          if(data.data.success==true){
            that.plan_temp_data=data.data.data.list
            that.plan_temp_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //区域温控点列表分页
      plan_temp_size_change(val){
        this.plan_temp_page_size=val
        //获取区域温控点列表
        this.get_plan_temp()
      },
      plan_temp_current_change(val){
        this.plan_temp_current_page=val
        //获取区域温控点列表
        this.get_plan_temp()
      },
      //查看平面图
      check_plan(row){
        let router_list=[]
        this.$store.state.openTab.forEach((item,index)=>{
          router_list.push(item.route)
        })
        if(router_list.includes('/record/check_plan')){
          this.$store.commit('delete_tabs','/record/check_plan')
        }
        this.$store.commit('add_tabs',{
          route:'/record/check_plan',
          name:row.areaName
        })
        this.$store.commit('set_active_index','/record/check_plan')
        this.$router.push({
          path:'/record/check_plan',
          query:{
            row:row
          }
        })
      },
      //删除平面图路径
      delete_plan(row){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/middle/warehouseImage/'+row.areaId
          }).then(data=>{
            if(data.data.success==true){
              //获取仓库平面图列表
              that.get_plan()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      }
    }
  }
</script>

<style scoped="scoped">
  /* 主信息表单、仓库货主信息、温控点审批、仓库温控点 */
  .search_form .el-form-item,
  .main_form .el-form-item,
  .customer_form .el-form-item,
  .temp_form .el-form-item,
  .plan_add_form .el-form-item{
    width: 49%;
    display: inline-block;
  }
  .approval_form .el-form-item{
    width: 32%;
    display: inline-block;
  }
  .temp_add_form .el-form-item{
    width: 32%;
    display: inline-block;
  }
  .search_form .form_other,
  .customer_form .form_other,
  .main_form .form_other,
  .approval_form .form_other,
  .temp_form .operate_button,
  .temp_add_form .form_other{
    width: 100%;
  }
  .approval_form  .upload_other div,
  .temp_form .operate_button div,
  .plan_add_form .upload_other div{
    display: inline-block;
  }
  @media screen and (max-width:720px) {
    .search_form .el-form-item,
    .customer_form .el-form-item,
    .temp_add_form .el-form-item{
      width: 100%;
    }
  }
  /* 其他 */
  .operate_btn{
    margin-right: 0px;
  }
  .operate_btn+.operate_btn{
    margin-left: 0px;
  }
  .el_details_row{
    display: flex;
    justify-content: space-between;
  }
  .db_detail_list{
    width: 30%;
  }
  .detail_tabs{
    width: 67%;
    margin-left: 10px;
  }
  .operate{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/record/storage.vue